import script from "./AppStoreIosProfileInstructionsPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppStoreIosProfileInstructionsPopup.vue?vue&type=script&setup=true&lang=ts"

import "./AppStoreIosProfileInstructionsPopup.vue?vue&type=style&index=0&id=908c4366&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-908c4366"]])

export default __exports__